import { useMemo } from "react";

import { ProgressSnapshot } from "@/domain/progress-snapshot/models/progress-snapshots-model";
import { useQuery } from "@apollo/client";

import { getProgressSnapshotsForKeyResultQueryDocument } from "./progress-snapshot.gql";

export interface UseGetProgressSnapshotListForKeyResultProps {
  keyResultId: string;
  enabled?: boolean;
}

export const useGetProgressSnapshotListForKeyResult = ({
  keyResultId,
  enabled = true,
}: UseGetProgressSnapshotListForKeyResultProps) => {
  const queryResult = useQuery(getProgressSnapshotsForKeyResultQueryDocument, {
    variables: { input: { keyResultId: keyResultId } },
    skip: !enabled,
  });

  const progressSnapshotList: ProgressSnapshot[] = useMemo(() => {
    if (!queryResult.data) {
      return [];
    }
    return queryResult.data.progressSnapshotsForKeyResult.slice().sort((a, b) => {
      const dateA = new Date(a.snapshotDate);
      const dateB = new Date(b.snapshotDate);

      return dateB.getTime() - dateA.getTime();
    });
  }, [queryResult.data]);

  return {
    queryResult,
    progressSnapshotList,
    loading: queryResult.loading,
    error: queryResult.error,
  };
};
